export const userEmploymentI18NPl = {
    employment: "Zatrudnienie",
    startDate: "Data początku",
    endDate: "Data końca",
    stillEmployed: "Nadal zatrudniony",
    addNew: "Dodaj nowy okres",
    back: "Wróć",
    present: "obecnie",
};
